"use client";

import env from "@/env.mjs";
import { useDPC } from "@/lib/depict/useDPC";
import { useSelection } from "@/lib/hooks/useSelection";
import usePersistedStore from "@/lib/stateManagement/persistedState/persistedStore";
import { CentraClientProvider } from "@frend-digital/centra/client";
import { NextUIProvider } from "@frend-digital/ui/next";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import Script from "next/script";
import type { PropsWithChildren, ReactNode } from "react";
import { useState } from "react";
import Events from "./_helpers/events";

const DepictDPCLoader = () => {
  useDPC();
  return null;
};
export default function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(() => new QueryClient());
  /*   const pathname = usePathname();

  useEffect(() => {
    const isProductPage = pathname?.startsWith("/product/");

    if (isProductPage) {
      document.body.classList.add("product-page-mobile");
    } else {
      document.body.classList.remove("product-page-mobile");
    }
  }, [pathname]); */

  return (
    <NextUIProvider>
      <QueryClientProvider client={queryClient}>
        <NewCentraProvider>
          <Events />
          {children}
        </NewCentraProvider>
        <ReactQueryDevtools initialIsOpen={false} />
        <DepictDPCLoader />
        <CentraCheckoutScript />
      </QueryClientProvider>
    </NextUIProvider>
  );
}

const CentraCheckoutScript = () => {
  const { data } = useSelection();

  if (!data?.selection?.centraCheckoutScript) return null;

  return (
    <Script id="centra-checkout-script">
      {`${data.selection.centraCheckoutScript}`}
    </Script>
  );
};

const NewCentraProvider = ({ children }: PropsWithChildren) => {
  const token = usePersistedStore((s) => s.token);
  return (
    <CentraClientProvider
      apiUrl={env.NEXT_PUBLIC_CENTRA_CHECKOUT_API}
      overrideToken={token}
    >
      {children}
    </CentraClientProvider>
  );
};
